import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOnboarded: false,
    answers: {},
}

const slice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setOnboarded: (state, action) => {
            state.isOnboarded = action.payload;
        },
        setAnswers: (state, action) => {
            state.answers = action.payload;
        },
        resetOnboarding: () => initialState,
    },
});

export const { setOnboarded, setAnswers, resetOnboarding } = slice.actions;

export default slice.reducer;